<script setup lang="ts">

import { ModalDefault } from '@shared/ui/modals'
import { AppDatePicker } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDisciplineScheduleStartDate } from '../../model/modal-discipline-schedule-start-date.hook'

defineOptions({
  name: 'ModalDisciplineScheduleStartDate',
})

const {
  refStartDate,
  refMinDate,
  refIsDisabled,
  setStartDate,
  close,
  back,
  confirm,
} = useModalDisciplineScheduleStartDate()
</script>

<template>
  <ModalDefault
    show
    title="Select start date"
    class-name="modal-discipline-schedule-step"
    is-close-button
    is-back-button
    @click:overlay="close"
    @click:close="close"
    @click:back="back"
  >
    <AppDatePicker
      class="modal-discipline-schedule-start-date"
      label="Start date"
      placeholder="Select here"
      :value="refStartDate"
      :min-date="refMinDate"
      @change="setStartDate"
    />
    <template #controls>
      <BtnPrimary
        text="Continue"
        color="emerald"
        :disabled="refIsDisabled"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
